var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.domains),function(domain){return _c('button',{key:domain,staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":"button"}},[_vm._v(" "+_vm._s(domain)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }